import Box from '@mui/material/Box'
import ContentGuide from 'global/guides/ContentGuide'
import React from 'react'

import ToolbarLog from './atoms/Toolbar'
import { columns } from './constants/columns'
import { useSseLog } from './services/useSseLog'

const LogsDatagrid: React.FC = () => {
    const { data, isLoading } = useSseLog()

    return (
        <Box
            role="panel"
            id="logs-tabpanel-0"
            aria-labelledby="logs-tab-0"
            height="100%"
        >
            <ContentGuide.DataGrid
                columns={columns}
                rows={data.sort(
                    (a: any, b: any) =>
                        new Date(b.createdAt).getTime() -
                        new Date(a.createdAt).getTime(),
                )}
                loading={isLoading}
                components={{
                    Toolbar: ToolbarLog,
                }}
            />
        </Box>
    )
}

export default LogsDatagrid
